import styled from "styled-components";
import {Paper} from "@mui/material";

export const ConfirmationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 25px 0;
`;

export const FormContainer = styled(Paper)`
  padding: 40px;
  //width: 100%;
  max-width: 500px;
`;

import { TextField } from "@mui/material";

export const StyledTextField = styled(TextField)`
  margin: 10px 0 !important;
`;

export const OptionDivider = styled.div`
  margin: 20px 0;
  text-align: center;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #e0e0e0;
    z-index: 1;
  }

  span {
    background-color: #fff;
    padding: 0 10px;
    z-index: 2;
    position: relative;
  }
`;

